import type { ReactNode } from "react";
import { site } from "@/config/site";
import { cn } from "@/utils/cn";

interface PageHeaderProps {
  title: string;
  lead?: string;
  /** e.g. "Export Invoices" → crumb "InvoiceVault / Export Invoices" */
  breadcrumbSuffix?: string;
  crumb?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  lead,
  breadcrumbSuffix,
  crumb,
  className,
}: PageHeaderProps) {
  const breadcrumb =
    crumb ??
    (breadcrumbSuffix ? (
      <span>
        {site.name} / {breadcrumbSuffix}
      </span>
    ) : null);

  return (
    <div className={cn("page-head-row", className)}>
      <div>
        <h1>{title}</h1>
        {lead ? <p className="page-lead-compact">{lead}</p> : null}
      </div>
      {breadcrumb ? <div className="crumb-right">{breadcrumb}</div> : null}
    </div>
  );
}
